import { Dispatch, SetStateAction } from 'react';
import Modal from '../Modal';
import CheckSuccess from '../Icons/CheckSuccess';

type Dictionary = {
  emailSent: string;
  description: string;
  descriptionExperience: string;
};

type Props = {
  dict: Dictionary;
  modalIsOpen: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
  type: string;
};

export default function EmailSentModal({
  dict,
  modalIsOpen,
  setModalIsOpen,
  type,
}: Props) {
  return (
    <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
      <Modal.Content contentCustomClass="" onOpenChange={setModalIsOpen}>
        <div className="text-center p-5">
          <div className="relative w-14 h-14 mb-4 mx-auto">
            <CheckSuccess />
          </div>
          <h3 className="mb-5 text-success text-medium font-semibold tracking-wider">
            {dict.emailSent}
          </h3>
          <p className="text-lg">
            {type === 'villas' ? dict.description : dict.descriptionExperience}
          </p>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
